<ng-content select="p" /> <ng-content select="label" />
